import { Autocomplete, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, Input, Modal, ModalDialog, Table, Typography } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { Mechanic } from "../Interfaces/Mechanic";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import WrappedButton from "../WrappedButton";
import PackingListNotesDialog from "../Dialogs/PackingListNotesDialog";
import { Dialog } from "@mui/material";
import SignatureCanvas from "react-signature-canvas";
import ReactSignatureCanvas from "react-signature-canvas";
export interface PackingList {
	BuildingName: string;
	InvoiceNumber: string;
	SerialNumber: string;
	Mechanic: string;
	InvoiceHeaderID: string;
	PackingListID: string;
	IsDropdownOpen: boolean;
	Notes: string;
}

export default function UnapprovedPackingList() {
	const [data, setData] = React.useState<Array<PackingList>>();
	const [mechanics, setMechanics] = React.useState<Array<Mechanic>>();
	const [signModal, setSignModal] = React.useState(false);
	const [packingList, setPackingList] = React.useState<String>();
	const [mechanic, setMechanic] = React.useState<String>();
	const [estimate, setEstimate] = React.useState<String>();
	const [pageNumber, setPageNumber] = React.useState(0);
	const [isSaving, setIsSaving] = React.useState(false);
	const [globalFilter, setGlobalFilter] = React.useState("");

	const [openDropdown, setOpenDropdown] = React.useState<Array<boolean>>([]);
	const [notesModal, setNotesModal] = React.useState(false);
	const [currentNotes, setCurrentNotes] = React.useState("");
	const [currentPackingListId, setCurrentPackingListId] = React.useState<string>("");

	let sigRef: any = null;

	const getMechanics = () => {
		fetch("User/GetMechanics", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => setMechanics(x));
	};

	React.useEffect(() => {
		getData();
		getMechanics();
	}, []);

	const getData = () => {
		sigRef && sigRef.clear();
		fetch("PackingList/GetPackingLists", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ approved: false }),
		})
			.then((x) => x.json())
			.then((x) => {
				const arr: Array<boolean> = [];
				setData(
					x.map((y: any) => {
						arr.push(false);
						return {
							BuildingName: y.building_name,
							InvoiceNumber: y.invoice_number,
							SerialNumber: y.serial_number,
							Mechanic: y.mechanic_name,
							InvoiceHeaderID: y.invoice_header_id,
							PackingListID: y.packing_list_id,
							IsDropdownOpen: false,
							Notes: y.notes ?? "",
						} as PackingList;
					})
				);
				setOpenDropdown(arr);
			});
	};
	/**
	 * Opens the notes dialog for a packing list
	 */
	const openNotesDialog = (inv: PackingList) => {
		setCurrentPackingListId(inv.PackingListID);
		setCurrentNotes(inv.Notes);
		setNotesModal(true);
	};

	const openPdf = (inv: PackingList) => {
		const data = fetch("Proposal/GetPdf", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				estimateNum: inv.InvoiceNumber,
				isPackingList: true,
				invoiceHeaderId: inv.InvoiceHeaderID,
			}),
		})
			.then((x) => x.text())
			.then((x) => {
				const blob = x;
				var tab = window.open();
				if (tab) tab.location.href = document.location.origin + "/pdfs/" + blob;
			});
	};

	const save = () => {
		if (sigRef.isEmpty()) {
			alert("A signature is required.");
			return;
		}
		setIsSaving(true);

		var dt = {
			base64Image: sigRef.toDataURL(),
			packingListId: packingList,
			estimateNumber: estimate,
			mechanicId: mechanic,
		};

		fetch("PackingList/SavePackingList", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(dt),
		}).then((x) => {
			setSignModal(false);
			setIsSaving(false);
			getData();
		});
	};
	const maxPages = Math.ceil((data ?? []).length / 25);
	const thisRows = data?.filter((x) => Util.isNullOrEmpty(globalFilter) || x.BuildingName.toLowerCase().includes(globalFilter.toLowerCase()) || x.InvoiceNumber.toString().includes(globalFilter)).slice(pageNumber * 25, (pageNumber + 1) * 25);
	return (
		<>
			<PackingListNotesDialog
				open={notesModal}
				packingListId={currentPackingListId}
				initialNotes={currentNotes}
				onClose={() => setNotesModal(false)}
				onSaved={() => {
					setNotesModal(false);
					getData();
				}}
			/>
			<Modal open={signModal}>
				<ModalDialog>
					<DialogTitle>Signature</DialogTitle>
					<DialogContent>
						<SignatureCanvas
							ref={(ref) => {
								sigRef = ref;
								console.log(sigRef);
							}}
							penColor="black"
							canvasProps={{ width: "900", height: "400", style: { border: "1px solid black", borderRadius: "8px" } }}></SignatureCanvas>
					</DialogContent>
					<DialogActions>
						<WrappedButton onClick={save} busy={isSaving}>
							Save Signature
						</WrappedButton>
						<Button
							onClick={() => {
								setSignModal(false);
							}}
							color="primary">
							Close
						</Button>
					</DialogActions>
				</ModalDialog>
			</Modal>
			<Box sx={{ overflowY: "auto", padding: 2 }}>
				<div style={{ display: "flex" }}>
					<div style={{ flex: 1 }}>
						<Typography level="title-lg">Pending Work Orders</Typography>
					</div>
					<FormControl sx={{ marginRight: 1 }}>
						<Input
							name="Search"
							placeholder="Global Search"
							onChange={(event) => {
								setGlobalFilter(event.target.value);
							}}
							value={globalFilter}
						/>
					</FormControl>
				</div>
				<Table stripe={"odd"} hoverRow>
					<thead>
						<tr>
							<th>Building Name</th>
							<th>Estimate #</th>
							<th>Serial #</th>
							<th>Mechanic</th>
							<th>Open PDF</th>
							<th>Notes</th>
						</tr>
					</thead>
					<tbody>
						{thisRows?.map((x, idx) => {
							return (
								<tr style={{ cursor: "pointer" }}>
									<td>{x.BuildingName}</td>
									<td>{x.InvoiceNumber}</td>
									<td>{x.SerialNumber}</td>
									<td>
										<Autocomplete
											open={openDropdown[idx]}
											onOpen={() => {
												x.IsDropdownOpen = true;
												const arr = ([] as Array<boolean>).concat(openDropdown);
												arr[idx] = true;
												setOpenDropdown(arr);
											}}
											options={mechanics ?? []}
											getOptionLabel={(opt) => opt.full_name}
											openOnFocus
											placeholder="Select Mechanic"
											onChange={(event, value) => {
												setSignModal(true);
												setPackingList(x.PackingListID);
												setMechanic(value?.users_id);
												setEstimate(x.InvoiceNumber);
												const arr = ([] as Array<boolean>).concat(openDropdown);
												arr[idx] = true;
												setOpenDropdown(arr);
											}}></Autocomplete>
									</td>
									<td>
										<WrappedButton
											onClick={() => {
												openPdf(x);
											}}>
											Open PDF
										</WrappedButton>
									</td>
									<td>
										<WrappedButton
											onClick={() => {
												openNotesDialog(x);
											}}>
											Notes
										</WrappedButton>
									</td>
								</tr>
							);
						})}
					</tbody>
					<tfoot>
						<tr>
							<td colSpan={6}>
								<div style={{ float: "right" }}>
									<span>
										<KeyboardArrowLeftIcon onClick={() => pageNumber > 0 && setPageNumber(pageNumber - 1)} sx={{ verticalAlign: "middle", cursor: "pointer" }} /> {`Page ${pageNumber + 1} of ${maxPages}`} <KeyboardArrowRightIcon onClick={() => maxPages > pageNumber + 1 && setPageNumber(pageNumber + 1)} sx={{ verticalAlign: "middle", cursor: "pointer" }} />
									</span>
								</div>
							</td>
						</tr>
					</tfoot>
				</Table>
			</Box>
		</>
	);
}
